/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { LiveStreamInfo, SanctioningBodyEnum } from 'models/viewModels';
import { StreamRequestType } from './RSocketObject';
import { RSocketStreamBaseService } from './RSocketStreamBaseService';

class LiveStreamServiceRSocket extends RSocketStreamBaseService<LiveStreamInfo[], LiveStreamInfo[]> {
  protected getStreamHistoryRequest(): Promise<LiveStreamInfo[]> {
    return Promise.resolve([]);
  }
  protected onDataCallback = (response: LiveStreamInfo[]) => {
    if (response && this.listeners.size > 0) {
      console.log(response);
      this.listeners.forEach((listener) => listener(response));
    }
  };
}

export const liveSessionServiceRSocket: Map<SanctioningBodyEnum, LiveStreamServiceRSocket> = new Map(
  (Object.values(SanctioningBodyEnum) as SanctioningBodyEnum[])
    .filter((x) => typeof x === 'number')
    .map((sanctioningBody) => [
      sanctioningBody,
      new LiveStreamServiceRSocket({
        route: 'stream.liveSessions',
        connectionType: StreamRequestType.MotorsportsStreamApi,
        sanctioningBody: sanctioningBody,
      }),
    ])
);
